import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HourglassRegular from './hourglass-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HourglassRegular {...validProps} />;
}
SvgComponent.iconName = 'hourglassRegular';

export const HourglassRegularIcon = svgIconWrapper(SvgComponent);
